<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="sidebar" app left temporary>
      <v-list nav dense class="sidebarWrapper">
        <v-list-item-group active-class="deep-purple--text text--accent-4">
          <div v-if="user !== null">
            <v-list-item :to="'/start'">
              <v-list-item-icon>
                <HomeIcon />
              </v-list-item-icon>
              <v-list-item-title>{{$t('appVue.start')}}</v-list-item-title>
            </v-list-item>

            <v-list-item :to="'/projects'">
              <v-list-item-icon>
                <TextIcon />
              </v-list-item-icon>
              <v-list-item-title>{{$t('appVue.text')}}</v-list-item-title>
            </v-list-item>

            <!-- <v-list-item :to="'/books'">
              <v-list-item-icon>
                <FileIcon />
              </v-list-item-icon>
              <v-list-item-title>Файл</v-list-item-title>
            </v-list-item> -->
          </div>
          <div v-else>
            <v-list-item :to="'/home'">
              <v-list-item-icon>
                <HomeIcon />
              </v-list-item-icon>
              <v-list-item-title>{{$t('appVue.home')}}</v-list-item-title>
            </v-list-item>
          </div>
          <v-list-item :to="'/help'">
            <v-list-item-icon>
              <QuestionIcon />
            </v-list-item-icon>
            <v-list-item-title>{{$t('appVue.help')}}</v-list-item-title>
          </v-list-item>
          <v-list-item :to="'/help'">
            <v-list-item-icon>
              <QuestionIcon />
            </v-list-item-icon>
            <v-list-item-title>{{$t('appVue.planInfo')}}</v-list-item-title>
          </v-list-item>

          <!-- <v-list-item @click="switchLocale">
            <v-btn icon text>
              <country-flag
                v-if="toggleLocale"
                country="mn"
                size="normal"
              ></country-flag>
              <country-flag v-else country="us" size="normal"></country-flag>
            </v-btn>
            <v-list-item-title>{{ $t("locale") }}</v-list-item-title>
          </v-list-item> -->
          <div class="paymentBtnWrapper">
            <v-btn
              v-if="user == null"
              @click="
                window.location.href = process.env.VUE_APP_BASE_URL + '/login'
              "
              class="paymentBtn"
              depressed
            >
              {{$t('appVue.login')}}
            </v-btn>
          </div>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar app dense elevation="0" v-if="!isMobileRoute">
      <Header
        :toggleLocale="toggleLocale"
        :switchLocale="switchLocale"
        :toggleSideBar="toggleSideBar"
        :noAuth="noAuth"
      />
    </v-app-bar>
    <div :class="!isMobileRoute ? 'main' : 'mainMobile'">
      <SideBar v-if="isAuth && !isMobileRoute" class="d-none d-sm-flex" />
      <router-view
        default="{path: '/'}"
        :class="isAuth && !isMobileRoute ? 'conWrapper' : 'landWrapper'"
      ></router-view>
    </div>
    <v-footer padlessa fixed v-if="isAuth == true && !isMobileRoute">
      <Footer />
    </v-footer>
    <v-footer padless v-else-if="!isMobileRoute"><FooterLand /> </v-footer>
    <v-dialog v-model="warningDialog" max-width="400">
      <v-card class="infoDialogWrapper">
        <div style="display:flex;margin-bottom:20px">
          <v-icon class="infoIcon">mdi-information-outline</v-icon>
          <div>
            {{$t('appVue.warnMsg')}}
          </div>
        </div>

        <div style="display:flex;justify-content:flex-end;">
          <v-btn class="infoBtn" text @click="warningDialog = false">за</v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="warningFileDialog" max-width="400">
      <v-card class="infoDialogWrapper">
        <div style="display:flex;margin-bottom:20px">
          <v-icon class="infoIcon">mdi-information-outline</v-icon>
          <div>
            {{$t('appVue.dialog')}}
          </div>
        </div>

        <div style="display:flex;justify-content:flex-end;">
          <v-btn class="closeBtn" @click="setWarningFileDialog(false)"
            >{{$t('appVue.closeBtn')}}</v-btn
          >
          <v-btn class="activeBtn" text @click="goPlanPage('/plan')"
            >{{$t('appVue.activeBtn')}}</v-btn
          >
        </div>
      </v-card>
    </v-dialog>
  </v-app>
</template>
<script>
// function toDateTime(secs) {
//   var t = new Date(1970, 0, 1); // Epoch
//   t.setSeconds(secs);
//   return t;
// }
import SideBar from "./components/SideBar";
import Footer from "./components/Footer";
import Header from "./components/Header";
import FooterLand from "./components/FooterLand";
// import FileIcon from "./components/icons/FileIcon";
import QuestionIcon from "./components/icons/QuestionIcon";
import HomeIcon from "./components/icons/HomeIcon";
import TextIcon from "./components/icons/TextIcon";
import { mapState, mapActions } from "vuex";
// import { invoiceListRequest, invoiceRequest } from "./invoice_pb";
// import { invoiceInfoClient } from "./invoice_grpc_web_pb";
export default {
  name: "App",
  components: {
    SideBar,
    Footer,
    Header,
    FooterLand,
    // FileIcon,
    HomeIcon,
    TextIcon,
    QuestionIcon,
  },
  data() {
    return {
      sidebar: false,
      isAuth: false,
      token: "",
      toggleLocale: true,
      userBuyInfo: {},
      isMobileRoute: false,
      warningDialog: false,
    };
  },
  computed: {
    ...mapState(["user", "warningFileDialog", "allPlan", "customerPlan"]),

    currentRouteName() {
      return this.$route.name;
    },
    getCurrentRoute: function() {
      return this.$router.currentRoute.name;
    },
  },
  created() {
    // this.client = new invoiceInfoClient(
    //   process.env.VUE_APP_GRPC_URL,
    //   null,
    //   null
    // );
    // this.getList();
    this.token = this.$cookie.get("token");
    if (this.token) {
      this.isAuth = true;
      this.updateUser(this.token);
      this.initCustomerPlan(this.token);
      this.initAllPlan();
      this.initTablePrice();
      this.updateBalance(this.token);
    } else {
      this.initAllPlan();
      this.initTablePrice();
      this.isAuth = false;
    }
    this.isMobileRouteFunc();
  },
  methods: {
    ...mapActions([
      "setWarningFileDialog",
      "updateUser",
      "initCustomerPlan",
      "initAllPlan",
      "initTablePrice",
      "updateBalance",
    ]),
    isMobileRouteFunc() {
      if (this.currentRouteName == "app") {
        this.isMobileRoute = true;
      } else {
        this.isMobileRoute = false;
      }
    },
    switchLocale() {
      this.toggleLocale = !this.toggleLocale;
      this.$i18n.locale = this.toggleLocale ? "mn" : "en";
    },
    redirectPricingPage(to) {
      let plan = this.allPlan.find(
        (plan) => plan.ID === this.customerPlan.PlanID
      );
      let isFile = plan.Feature.privilege.split(",").indexOf("file");
      if (isFile != -1) {
        this.$router.push(to).catch((err) => {
          console.log(err);
        });
      } else {
        this.setWarningFileDialog(true);
      }
    },
    noAuth() {
      this.isAuth = false;
    },
    toggleSideBar() {
      this.sidebar = !this.sidebar;
    },
    goPlanPage(to) {
      this.setWarningFileDialog(false);
      this.$router.push(to).catch((err) => {
        console.log(err);
      });
    },
  },
};
</script>

<style>
#app {
  font-family: "Roboto", sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* background-color: #cce2ff; */
}

html,
body {
  /* background-color: #f7faff; */
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  /* background-position: center; */
  /* background-repeat: no-repeat; */
  /* background-size: cover; */
}

.main {
  display: flex;
  min-height: calc(100vh - 48px);
  padding-top: 58px;
}

.mainMobile {
  display: flex;
  min-height: calc(100vh - 48px);
}

.conWrapper {
  margin: 35px 35px 48px 111px;
}

.landWrapper {
  width: 100%;
}

@media screen and (max-width: 599px) {
  .conWrapper {
    margin: 35px 10px;
  }
  .dNoneStyle {
    display: none;
  }
}

.toolbarLink {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 56px;
  border-bottom: 2px solid #ffffff;
  transition: all ease-in-out 0.3s;
}

.toolbarLink:hover {
  border-bottom: 2px solid #777ff6;
  transition: all ease-in-out 0.3s;
}

.navButton {
  color: #808080 !important;
  font-size: 14px !important;
  text-transform: initial !important;
  background-color: #ffffff !important;
}

.navButton::before {
  background-color: transparent !important;
}

.loginButton {
  background-color: #787ff7 !important;
  color: white !important;
  font-size: 12px !important;
  outline: none !important;
}

.paymentBtnWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 0;
  border-top: 1px solid #e5e5e5;
}

.paymentBtn {
  font-weight: 500;
  color: #777ff6 !important;
  background-color: #777ff6 !important;
  text-transform: initial !important;
}

.v-footer {
  padding: 0 !important;
}

.v-toolbar__content {
  display: flex;
  width: 100%;
  background-color: #ffffff;
  flex-wrap: wrap;
  height: 58px !important;
  border: 1px solid #e5e5e5;
  padding: 0 !important;
}

.sidebarWrapper {
  padding: 8px !important;
}

.v-btn {
  letter-spacing: 0 !important;
}

.link {
  text-decoration: none;
}

.infoDialogWrapper {
  display: flex;
  flex-direction: column;
  padding: 25px;
}

.infoIcon {
  color: #777ff6 !important;
  margin-right: 10px;
}

.infoBtn {
  display: flex;
  background-color: #777ff6 !important;
  text-transform: initial;
  color: #ffffff !important;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  margin-right: 5px;
  height: 34px !important;
  width: 64px !important;
}

.activeBtn {
  display: flex;
  background-color: #777ff6 !important;
  text-transform: initial;
  color: #ffffff !important;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  margin-right: 5px;
  height: 34px !important;
  width: auto;
}

.closeBtn {
  background-color: #ffffff !important;
  text-transform: initial;
  color: #767676 !important;
  border: 2px solid #e5e5e5;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  margin-right: 10px;
  height: 34px !important;
  width: 64px !important;
}
</style>
